import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "components/common/pagination";
import { useLocation } from "react-router-dom";
import { DateTimeFormat } from "utils/dateFormat";
import Dropdown from "utils/dropdown";
import processParams from "utils/processParams";
import useToolkit from "utils/useToolkit";
import * as paymentActions from "store/entities/payments/action";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import SingleSplitModal from "./SingleSplitModal";


const SplitInstructionsTable = () => {
	const {
		useState,
		useEffect,
		dispatch,
		useSelector,
		Spinner,
		isFinancialAdmin,
		isSuperAdmin,
		CurrencyFormat,
		dropdownTableIcon,
	} = useToolkit();

	const { splitInstructionsLoading: isLoading, splitInstructionsData: splits } =
		useSelector((state) => state.entities.payments);

	const {urlQueryParams} = useUrlQueryParams();
	// eslint-disable-next-line
				const location = useLocation()

				const [listParams, setListParams] = useState({
        page: 1,
        limit: 20,
        status: "",
    });

				    const getSplits = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        
        setListParams(params);
								dispatch(paymentActions.getSplitInstructions(params));
    }

	const [selectedSplit, setSelectedSplit] = useState(null)
	const [splitModalOpen, setSplitModalOpen] = useState(false)
	const handlers = splits?.data?.docs;
	const emptyTableData = isLoading === false && !handlers;

	useEffect(() => {
		getSplits()
		// eslint-disable-next-line
	}, [location]);


	return isLoading ? (
		<Spinner />
	) : (
		<div className="w-full">
			<div className="mt-10">
				<div className="">
					<div className="table-container">
						<table className="table table-auto table-rounded table-border table-align-tope">
							<thead>
								<tr>
									<th>Date</th>
									<th>Amount</th>
									<th>Description</th>
									<th>Reference</th>
									<th>Type</th>
									<th>Wallet ID</th>
									<th>Status</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{emptyTableData ? (
									<tr>
										<td colSpan={isSuperAdmin || isFinancialAdmin ? "10" : "9"}>
											<div className="table-info">
												<FontAwesomeIcon icon="unlink" />
												<div className="font-bold uppercase">
													An error occurred
													<br />
													Please try again later.
												</div>
											</div>
										</td>
									</tr>
								) : (
									handlers?.map((handler, index) => {
										const amount = CurrencyFormat(handler?.amount / 100)
										return ( <tr key={index}>
											<td>{DateTimeFormat(handler?.createdAt)}</td>
											<td>{amount}</td>
											<td>{handler?.description || 'N/A'}</td>
											<td>{handler?.reference  || 'N/A'}</td>
											<td className="capitalize">{handler?.type}</td>
											<td className="capitalize">
												{handler?.walletId}
											</td>
											<td className="capitalize">
												<div
													className={`label ${
														handler?.status === "completed"
															? "label-green"
															: handler?.status === "pending"
															? "label-gray"
															: "label-red"
													}`}>
														{handler?.status}
												</div>
											</td>
											<td>
												<div className="table-dropdown-align-top">
													<Dropdown
														icon={dropdownTableIcon}
														menu={[
															{
																type: "div",
																text: "View Details",
																click: () => {
																	setSelectedSplit(handler)
																	setSplitModalOpen(true)
																	}
																}
														]}
													/>
												</div>
											</td>
										</tr>
									)})
								)}
							</tbody>
						</table>
					</div>

					{isLoading === false && handlers?.length && (
						<div>
							<Pagination
								data={splits.data}
								limit={listParams.limit}
							/>
						</div>
					)}
				</div>
			</div>
				<SingleSplitModal
					selectedSplit={selectedSplit}
					control={splitModalOpen}
					onClose={() => setSplitModalOpen(false)}
				/>
		</div>
	);
};

export default SplitInstructionsTable;
